import React from "react";
import ContactForm from "./ContactForm";

export default function ServicePage({ hero, children, onNavigate }) {
  return (
    <>
      {/* Service Hero */}
      <section className="hero-service">
        <div className="hero-service-inner">
          <div className="hero-service-left">
            <h1>{hero.title}</h1>
          </div>
          <div className="hero-service-right">
            <p>{hero.description}</p>
          </div>
        </div>
        <div className="service-hero-img">
          <img src={hero.image} alt={hero.title} />
        </div>
      </section>

      {children}

      <ContactForm />
    </>
  );
}
